import React from 'react'

const PanasonicAVHSW10CompactSwitcher = () => {
  return (
    <div>PanasonicAVHSW10CompactSwitcher</div>
  )
}

export default PanasonicAVHSW10CompactSwitcher